module.exports = __webpack_public_path__ + "static/media/exclamation.4e0bb1a4.svg";